module.exports = __webpack_public_path__ + "media/images/admin/icons/aperture-09da64237cef340d981a3cb3615e1308.svg";